export default {
    title: 'Trend evaluation',
    label: 'Choose trend radar',
    empty: {
        title: 'Looking for the rating?',
        content: 'Unfortunately, there is nothing to see here yet.<br />Please be patient!'
    }
}
